import apiHandler from "./apiHandler";

import { defaultPagination } from "@/utils/helpers";

const apiPilots = {
  login: (email, password) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post("/pilot/login", {
          email: email,
          password: password,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout: () => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/pilot/logout")
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getTrafficToken: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/pilot/traffic/token`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err, response) => {
          reject(err);
        });
    });
  },
  getAirframeBySimName: (simName) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/airframe/find`, { simName })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err, response) => {
          reject(err);
        });
    });
  },
  basic: (id, showErrors = true) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/pilot-basic/" + id, { showErrors })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  profile: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/pilot/" + id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  awards: (id, pagination, needle, includeClosed = false) => {
    return new Promise((resolve, reject) => {
      pagination = defaultPagination(pagination);
      apiHandler
        .post(`/pilot/awards`, {
          id: id,
          skip: (pagination.page - 1) * pagination.rowsPerPage,
          count: pagination.rowsPerPage,
          needle: needle,
          sort: pagination.sortBy !== null ? pagination.sortBy : "",
          order: pagination.descending ? -1 : 1,
          includeClosed: includeClosed,
        })
        .then((response) => {
          pagination.rowsNumber = response.data.totalResults;
          resolve({
            results: response.data.results,
            pagination,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  integration: {
    getOne: (name) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get(`/pilot/integration/${name}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    removeOne: (name) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .delete(`/pilot/integration/${name}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default apiPilots;
